var render = function render(){var _vm=this,_c=_vm._self._c;return _c('compWrapper',{attrs:{"title":"操作历史","theme":"gray"}},[_c('vTableSimple',{staticClass:"bg-fff margin-10",attrs:{"columns":_vm.columns,"data":_vm.data,"border":"","stripe":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }